import { Components, Theme } from '@mui/material';

export const MuiTab: Components<Theme>['MuiTab'] = {
  styleOverrides: {
    root: {
      textTransform: 'none',
      paddingX: '16px',
      paddingY: '14px',
      color: '#000000',
      '&.Mui-selected': {
        color: '#19b5d2 ',
      },
    },
  },
};
